import type React from 'react';
import loadable from '@loadable/component';
import type { BedBathComboFilterProps } from 'app/shared/modules/MobileSRP/Header/FilterModules/BedBathComboFilter/component';

const BedBathComboFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "BedBathComboFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/BedBathComboFilter/component'
    ),
);

const LoadableBedBathComboFilter: React.FC<BedBathComboFilterProps> = (props) => {
  return <BedBathComboFilter {...props} />;
};

export default LoadableBedBathComboFilter;
